import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/messaging/logs/')({
  beforeLoad: () => {
    throw redirect({ to: '/correo/logs' });
  },
});
